import React, { useState } from "react";

const Navigation: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Inicio", href: "#inicio" },
    { name: "Acerca", href: "#acerca" },
    { name: "Habilidades", href: "#habilidades" },
    { name: "Experiencia", href: "#experiencia" },
    { name: "Proyectos", href: "#proyectos" },
    { name: "Educación", href: "#educacion" },
    { name: "Contacto", href: "#contacto" },
  ];

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Estilos CSS integrados */}
      <style >{`
        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .nav-header {
          background-color: #2563eb;
          color: white;
          position: sticky;
          top: 0;
          z-index: 50;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -2px rgba(0, 0, 0, 0.05);
        }

        .nav-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 4rem;
        }

        .nav-logo {
          font-size: 1.25rem;
          font-weight: 700;
        }

        .nav-menu {
          display: flex;
          gap: 1rem;
        }

        .nav-link {
          background: transparent;
          color: white;
          padding: 0.75rem 0.5rem;
          border-radius: 0.375rem;
          font-size: 0.875rem;
          font-weight: 500;
          border: none;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .nav-link:hover {
          background-color: #1d4ed8;
        }

        .nav-toggle {
          display: none;
          background: none;
          border: none;
          color: white;
          font-size: 1.5rem;
          cursor: pointer;
          padding: 0.5rem;
        }

        .nav-mobile {
          display: none;
          background-color: #1d4ed8;
          padding: 1rem 0;
          border-top: 1px solid #1e40af;
        }

        .nav-mobile.open {
          display: block;
        }

        .nav-mobile-link {
          display: block;
          width: 100%;
          text-align: left;
          padding: 0.75rem 1rem;
          color: white;
          background: none;
          border: none;
          font-size: 1rem;
          font-weight: 500;
          cursor: pointer;
        }

        .nav-mobile-link:hover {
          background-color: #1e40af;
        }

        @media (max-width: 1023px) {
          .nav-menu {
            display: none;
          }

          .nav-toggle {
            display: block;
          }

          .nav-mobile.open {
            display: block;
          }
        }

        /* Evita scroll horizontal */
        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          overflow-x: hidden;
        }
      `}</style>

      <nav className="nav-header">
        <div className="nav-container">
          <div className="nav-inner">
            {/* Logo */}
            <div>
              <span className="nav-logo">RAAV</span>
            </div>

            {/* Menú Desktop */}
            <div className="nav-menu">
              {navItems.map((item) => (
                <button
                  key={item.href}
                  onClick={() => scrollToSection(item.href)}
                  className="nav-link"
                >
                  {item.name}
                </button>
              ))}
            </div>

            {/* Botón Hamburguesa */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="nav-toggle"
              aria-label="Toggle menu"
            >
              {isOpen ? "Close" : "Menu"}
            </button>
          </div>

          {/* Menú Móvil */}
          <div className={`nav-mobile ${isOpen ? "open" : ""}`}>
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => scrollToSection(item.href)}
                className="nav-mobile-link"
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navigation;